import { Dispatch, SetStateAction } from 'react'

import { MASTER_SEARCH_CONDITION_CLEAR, MasterSearchCondition } from '@/common/api/modules/master'
import { isSameSearchCondition } from '@/common/api/search'

import Button from '@/components/view/atoms/button/Button'
import TextField, { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'
import FormRow from '@/components/view/layouts/form/FormRow'

interface ItemProps {
  condition: MasterSearchCondition
  setCondition: Dispatch<SetStateAction<MasterSearchCondition>>
}

interface Props extends ItemProps {}

const MasterSearchConditionField = ({ condition, setCondition }: Props) => {
  const isDefault = isSameSearchCondition(condition, MASTER_SEARCH_CONDITION_CLEAR)

  return (
    <>
      <SearchConditionAreaContent>
        <FormRow gap={8} size={TextBoxSize.FULL} align='center'>
          <TextField
            type={'search'}
            size={TextBoxSize.FULL}
            value={condition.keyword ?? ''}
            onChange={(e) =>
              setCondition((condition) => {
                return {
                  ...condition,
                  page: 1,
                  keyword: e.target.value
                }
              })
            }
            placeholder='マスタを検索する'
          />
        </FormRow>
        <SortButtonList>
          <Button
            color='secondary'
            disabled={isDefault}
            onClick={() => setCondition(MASTER_SEARCH_CONDITION_CLEAR)}
          >
            条件をリセット
          </Button>
        </SortButtonList>
      </SearchConditionAreaContent>
    </>
  )
}

export default MasterSearchConditionField
